module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/portfolio-item-1-20f0c5124d4e976011f01616c2c47838.jpg";